import { isEmpty } from 'lodash';

import {
    REQUEST_UPDATE_PASSWORD,
    SUCCESS_UPDATE_PASSWORD,
    FAILURE_UPDATE_PASSWORD,
    RESET_FORM_SUBMIT_UPDATE_PASSWORD
} from './constants';
import { HTTP_METHOD_PUT } from '../../../constants/httpMethod';

import { makeActionCreator } from '../../../utils/actionsUtils';

import { CALL_API } from '../../../middlewares/api';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_UPDATE_PASSWORD);

export function sendPasswordUpdateRequest(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/user/password',
            method: HTTP_METHOD_PUT,
            types: [REQUEST_UPDATE_PASSWORD, SUCCESS_UPDATE_PASSWORD, FAILURE_UPDATE_PASSWORD],
            body: formData,
            successCallback: () => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/password/actions.js